<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span @click="updateStatus">{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'ดำเนินการแล้ว') return 'success'
        return 'danger'
      }
    }
  },
  methods:{
    updateStatus(){
      console.log(this.params.data.key);
      if(this.params.data.status !== 'ดำเนินการแล้ว' && this.params.data.status !== 'ยกเลิก'){
        this.$store.commit('historyManagement/SET_SELECTED', this.params.data);
        this.$store.commit('historyManagement/SET_POPUP', true);
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
